<template>
    <div class="d-flex flex-column h-100">
        <div
            :class="[
                'd-flex shadow align-items-center overview-rounded p-1 pl-2 overview-info-wrapper h-100',
                ,
                shadowedBoxClass || '',
            ]"
        >
            <div
                :class="[
                    'd-flex align-items-center justify-items-center overview-info info-box-icon-wrapper',
                    colorClass,
                ]"
            >
                <div class="m-auto d-flex">
                    <template>
                        <slot name="icon">
                            <font-awesome-icon class="text-white" :icon="icon" size="lg" />
                        </slot>
                    </template>
                </div>
            </div>

            <template>
                <slot name="text">
                    <div class="ml-1 text-truncate">
                        <template>
                            <slot name="title">
                                <h6 class="p-0 m-0 mb-25">{{ header }}</h6>
                            </slot>
                        </template>
                        <template>
                            <slot name="description">
                                <p class="p-0 m-0 engage-font-md text-secondary">{{ text }}</p>
                            </slot>
                        </template>
                    </div>
                </slot>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        header: {
            type: String | Number,
            required: true,
        },
        text: {
            type: String | Number,
            required: true,
        },
        colorClass: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: false,
        },
        shadowedBoxClass: {
            type: String,
            required: false,
        },
    },
};
</script>
<style lang="scss">
@import "~@/assets/scss/modules/engage/messageOverview.scss";
</style>
